import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsLastNameViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map